



































import {Component, PropSync} from "vue-property-decorator";
import {DatePickerWings, FastDateGroupWings, FilterWings, SelectWings} from "@/components";
import {Action, Mutation} from "vuex-class";
import {SummaryFilter} from "@/store/reports/types";
import FilterSelectedItemWings from "@/components/Filter/FilterSelectedItemWings.vue";
import BaseFilter from "@/components/Filter/BaseFilter";
import {currentDay, onlyDateFilter} from "@/utils/date-util";
import {notifyError, notifyWarning} from '@/utils/notify-helper';

@Component({
  components: {
    DatePickerWings,
    FastDateGroupWings,
    FilterSelectedItemWings,
    FilterWings,
    SelectWings,
  },
  filters: {
    onlyDateFilter
  }
})
export default class SummaryGroupFilter extends BaseFilter<SummaryFilter> {
  @PropSync('show') is_show!: boolean;

  @Mutation('setSummaryGroup') setStatistic: any

  @Action("getSummaryGroup") actionGetItems: any;
  @Action("exportSummaryStatisticGroup") actionExport: any;

  defaultFilter():SummaryFilter {
    return {
      date_from: currentDay(),
      date_to: currentDay(),
      message_direction: 'mt'
    }
  }

  created() {
    this.setStatistic(null)
  }

  async onFilteredAction() {
    try {
      const resp = await this.actionGetItems(this.filter);
      if (resp.status === 204) {
        notifyWarning()
      }
    } catch(err) {
      notifyError(err)
    }
  }

  // Override
  async doActionExport() {
    return await this.actionExport(this.filter);
  }

}
